import { diff } from 'util/date'
import debug from 'util/debug'
import { anyRequestsLeft } from 'ducks/requests/concurrencyManager'
import { hasPendingDraftWork } from 'ducks/drafts2/operations/pendingDraftWork'
import { claimChannelReload } from 'util/releaseChannel'

// This middleware installs a method of making the
// next navigation navigate using location.href, effectively
// refreshing the whole page without impacting user experience
const MIN_REFRESH_MINS = 10
let shouldRefreshOnNextPage = false
let forceRefresh = false
let lastRefreshTime

export const refreshOnNextPage = () => {
  shouldRefreshOnNextPage = true
}

export const forceRefreshOnNextPage = () => {
  shouldRefreshOnNextPage = true
  forceRefresh = true
}

export const refreshMiddleware = () => next => action => {
  const now = new Date()

  if (!lastRefreshTime) lastRefreshTime = now

  const minutesSince = diff('minutes', lastRefreshTime, now)
  const shouldRefresh =
    shouldRefreshOnNextPage &&
    (forceRefresh || minutesSince >= MIN_REFRESH_MINS)

  if (
    shouldRefresh &&
    action.meta &&
    action.meta.location &&
    !anyRequestsLeft() &&
    (!forceRefresh ||
      (!window.onbeforeunload &&
        !hasPendingDraftWork() &&
        claimChannelReload()))
  ) {
    lastRefreshTime = now
    const { pathname } = action.meta.location.current
    debug('Auto-refreshing...', { minutesSince, lastRefreshTime })
    window.location.href = pathname
    return
  }

  if (shouldRefreshOnNextPage && !shouldRefresh) {
    debug('Auto-refresh throttled', { minutesSince, lastRefreshTime })
  }

  // eslint-disable-next-line consistent-return
  return next(action)
}
